import './bootstrap'
import { useGlobalStore } from '@stores/global'
import { useServiceStore } from '@stores/service'
import { useProjectStore } from '@stores/project'
import { useNewsStore } from '@stores/news'
import { createApp } from 'vue/dist/vue.esm-bundler'
import { createPinia } from 'pinia'
import router from './router'
import { initResponsive } from '@utils/responsive'
import { createHead } from '@unhead/vue/client'
import { TemplateParamsPlugin } from 'unhead/plugins'

import clickOutside from '@directives/clickOutside'

window.ga = function () {
	;[].push(arguments)
}

/* App Setup */
const pinia = createPinia()
const head = createHead()
head.use(TemplateParamsPlugin)
const app = createApp({}).use(router).use(pinia).use(head)

// head.push({
// 	titleTemplate: '%s %separator %siteName',
// 	templateParams: {
// 		separator: '•',
// 		siteName: 'Paper Crowns',
// 	},
// })

/* Stores */
const global = useGlobalStore()
const service = useServiceStore()
const project = useProjectStore()
const news = useNewsStore()

/* Directives */
app.directive('click-outside', clickOutside)

/* Setup Stores */
global.setup()
service.setup()
project.setup()
news.setup()

/* Mount App */
app.mount('#papercrowns')

/* Initialize responsive tracking */
initResponsive()
